import React, { useState } from 'react';
import { useQuery } from 'react-query';
import GroupIcon from '@mui/icons-material/Group';
import { ModalWrapper, Tag, UserName, UserRole, UserRoleSwitchContainer } from './navbar.style';
import { useUserContext } from '../../../hooks/UserContext';
import * as UserService from '../../../services/bioplus-services/user';
import { Modal } from '../../../Components/uielements';
import { IntlMessages } from '../../../helper/langHelper';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const UserRoleSwitch = ({ user }) => {
  const userContext = useUserContext();
  const roleQuery = useQuery('my_roles', () => UserService.getRoles());
  const [selectRole, setSelectRole] = useState(undefined);

  const navigate = useNavigate();

  const handleSelectedRole = () => {
    if (roleQuery?.data?.length > 1) {
      setSelectRole(roleQuery.data);
    }
  };
  const selectedRole = userContext?.company;
  const selectCompany = (role) => {
    userContext.setCompany(role);
    if (role?.permission) {
      userContext.setUserPermission(role?.permission);
    } else {
      userContext.setUserPermission([]);
    }
    navigate('/');
  };

  return (
    <>
      <UserRoleSwitchContainer onClick={handleSelectedRole}>
        <GroupIcon />
        <div style={{ display: 'grid', gap: '10px' }}>
          <UserName transform="capitalize">
            {!!user ? `${user?.firstName} ${user?.lastName}` : ''}
          </UserName>
          <UserRole>{userContext?.company?.label ?? 'VISITOR'}</UserRole>
        </div>
        <ArrowForwardIcon style={{ position: 'absolute', right: '5px' }} />
      </UserRoleSwitchContainer>
      {selectRole && (
        <RoleChangeModal
          roles={selectRole}
          onClose={() => setSelectRole(undefined)}
          onSelect={(role) => selectCompany(role)}
          selectedRole={selectedRole}
        />
      )}
    </>
  );
};

export default UserRoleSwitch;

const RoleChangeModal = ({ roles, onClose, onSelect, selectedRole }) => {
  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="nav.drop.down.role.select.label" />}
      >
        <ModalWrapper>
          {roles.map((role) => (
            <div
              style={{ display: 'grid', gap: '10px', position: 'relative' }}
              onClick={() => onSelect(role)}
            >
              <UserName>{role.role === 'ADMIN' ? 'AGM' : role?.companyId?.name}</UserName>
              <UserRole>{role?.label}</UserRole>
              {selectedRole?.role === role?.role && (
                <Tag style={{ position: 'absolute', right: '0px' }}>Selected</Tag>
              )}
            </div>
          ))}
        </ModalWrapper>
      </Modal>
    </>
  );
};
